import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyNotifications = lazy(() => import('./Notifications'));

export const Notifications: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyNotifications {...props} />
	</Suspense>
);
